module.exports = __webpack_public_path__ + "static/img/hetong.ac492e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_new/hetong.png
// module id = tmyB
// module chunks = 0